<template>
  <v-dialog v-model="dialogIsOpen" max-width="320" :persistent="true" content-class="inside-plan-form-dialog">
    <v-card class="dialog-box home-form-container">
      <h2 class="cassette-title">{{ action === "create" ? `${$t('New')}` : `${$t('Edit')}` }} {{ $t('Cassette') }}</h2>
      <div class="cassette-label-input mb-4">
        <label class="mb-1">{{`${$tc('Label',1)} *`}}</label>
        <input
          v-model="object.label"
          type="text"
        />
      </div>
      <div v-if="action === 'create'" class="cassette-form-item mb-5" >
        <label class="mb-1">{{`${$tc('MaterialReference',1)} *`}}</label>
        <treeselect
          :options="cassetteOptions"
          :normalizer="cassetteOptionsNormalizer"
          v-model="object.material_id"
          disableFuzzyMatching
          class="cassette-form-input-select"
        />
      </div>
      <v-card-actions class="cassette-form-buttons">
        <v-btn
          @click="$emit('close-cassette-form')"
          :ripple="false"
          class="secondary-button"
          text
        >
            {{ $t("Cancel") }}
        </v-btn>
        <v-btn
          :disabled="isDisabled"
          @click="saveObject"
          :ripple="false"
          class="main-button"
          text
        >
          {{action === "create" ? $t("Save") : $t("Edit")}}
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import InputField from "@/components/Home/Forms/_Molecules/InputField";
import _ from "lodash";

export default {
  name: "AddOrEditCassetteForm",

  components: {
    InputField,
  },

  props: {
    dialogIsOpen: {
      type: Boolean,
      required: true
    },
    itemToEdit: {
      type: Object
    },
    cassetteOptions: {
      type: Array
    }
  },

  mounted() {
    this.setEditData();
  },

  data() {
    return {
      object: {
        material_id: null,
        label: null,
      },
    };
  },

  computed: {
    isDisabled(){
      return this.action === 'create' ? !(!!this.object.label && !!this.object.material_id) : !this.object.label;
    },

    action() {
      return this.itemToEdit && Object.keys(this.itemToEdit).length > 0 ? "edit" : "create";
    },

    changesMade() {
      if (this.action === "edit" && this.object.label === this.itemToEdit.ct_label) {
        return false;
      } else {
        return true;
      }
    }
  },

  methods: {
    saveObject: _.debounce(function () {
      let actionToEmit = this.changesMade ? `${this.action}-cassette` : 'close-cassette-form';
      this.$emit(actionToEmit, this.object);
    }, 100),

    setEditData(){
      if(this.action === "edit"){
        this.object.label = this.itemToEdit.ct_label;
        this.object.material_id = this.itemToEdit.ct_material_id;
      }
    },

    cassetteOptionsNormalizer(material) {
      return {
        id: material.sm_id,
        label: material.sm_short_description ? material.sm_short_description : material.sm_description
      }
    },
  },
}
</script>

<style>
.inside-plan-form-dialog.v-dialog--active {
  overflow-y: visible !important;
}
</style>

<style scoped>
.cassette-form-item, .cassette-label-input{
    width: 100%;
    padding-left: 5px;
    font-family: 'Lato', sans-serif;
    text-align: left;
    font-size: 12px;
}
.cassette-label-input{
    display: flex;
    flex-direction: column;
    align-items: flex-start;
}
.cassette-label-input input {
    width: 100%;
    height: 32px;
    border: 1px solid black;
    border-radius: 8px;
    padding-left: 10px;
}
.cassette-title{
    color: #42A1B6;
    text-align: start;
    padding-left: 5px;
    margin-bottom: 10px;
}
.input-field{
  padding: 4px 0px !important;
  padding-left: 5px !important;
}
.cassette-form-input-select >>> .vue-treeselect__control{
  border: 1px solid black;
  border-radius: 8px !important;
}
.cassette-form-input-select:hover >>> .vue-treeselect__control:hover {
  border: 1px solid black;
}
.cassette-form-buttons{
  padding-right: 0px !important;
}
.cassette-form-input-select .vue-treeselect__menu-container .vue-treeselect__menu{
  max-height: 90px !important;
}

</style>


// WEBPACK FOOTER //
// src/components/Home/Content/Tabs/InsidePlan/forms/AddOrEditCassetteForm.vue